// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import TrailerController from "./trailer_controller";
application.register("trailer", TrailerController);

import SearchController from "./search_controller";
application.register("search", SearchController);

import CookieConsentController from "./cookie_consent_controller";
application.register("cookie-consent", CookieConsentController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import MobileMenuController from "./mobile_menu_controller";
application.register("mobile-menu", MobileMenuController);

import MovieNotificationController from "./movie_notification_controller";
application.register("movie-notification", MovieNotificationController);

import NotificationDropdownController from "./notification_dropdown_controller";
application.register("notification-dropdown", NotificationDropdownController);

import TurboFormController from "./turbo_form_controller";
application.register("turbo-form", TurboFormController);

// New controller for handling watchlist button width preservation
import WatchlistButtonController from "./watchlist_button_controller";
application.register("watchlist-button", WatchlistButtonController);

import MovieSelectController from "./movie_select_controller";
application.register("movie-select", MovieSelectController);

import MovieFormController from "./movie_form_controller";
application.register("movie-form", MovieFormController);

import CalendarController from "./calendar_controller";
application.register("calendar", CalendarController);
